export default { sha: '081b80ef4b05fe8d22ab454c4907e9976fa07ccb', buildNumber: 'undefined' }
